<template>
    <div>
        <tipsDialog :dialogVisible="loadingDialogVisible" :tipsMessage="loadingMsg"></tipsDialog>

        <tipsDialog  :tipsMessage="exitTitle"
                     :dialogVisible="restoreDialogVisible">
                     <div class="text-btn" @click="recoverDish">收回托盘</div>
        </tipsDialog>
        <tipsDialog  tipsMessage="闸门处有异物，请清理后点击关闭闸门"
                     :dialogVisible="restoreDishDialogVisible">
            <div class="text-btn" @click="resetCloseDish">关闭闸门</div>
        </tipsDialog>
        <tipsDialog  :tipsMessage="`超时未取出退票，将在 ${countDownNum} 秒后收回托盘`"
                     :dialogVisible="timeoutDishDialogVisible">
            <div class="text-btn" @click="cancleRecoverDish">取消</div>
        </tipsDialog>

        <errorDialog :errorMessage="paperErrorMessage" :dialogVisible="paperErrorDialogVisible"></errorDialog>
    </div>
</template>
<script>
import errorDialog from '@/components/errorDialog'
import tipsDialog from '@/components/tipsDialog'
import paperDishMixin from '@/mixin/paperDishMixin'
export default {
    components: {
        errorDialog,
        tipsDialog
    },
    mixins: [ paperDishMixin ],
    props:{
        exitTitle:{
            type: String,
            default:'请取走原始凭证'
        }
    },
    data(){
        return {
            // 中间态loading
            loadingDialogVisible: false,
            loadingMsg: '正在操作中，请稍后...',
            // 不可处理错误信息
            paperErrorMessage: '设备异常',
            paperErrorDialogVisible: false,
            // 业务弹窗
            restoreDialogVisible: false,
            restoreDishDialogVisible: false,
            // 超时提示弹窗
            timeoutDishDialogVisible: false,
            intervalTime: 2 * 60 * 1000, // 超时未操作
            dishNotCloseTimer: null,
            countDownNum: 15,
        }
    },
    methods:{
        // 检测托盘是否有纸
        getDishHavePaper(){
            //  检查托盘是否有纸
            this.checkPaperDishSensor().then(res => {
                if(res.status === 0){
                    // 托盘有纸，进入退纸流程
                    this.loadingDialogVisible = true
                    this.loadingMsg = '正在退出原始凭证...'
                    this.ejectFile().then(_res=> {
                        this.closeAllDialog()
                        this.restoreDialogVisible = true
                        this.handleDishNotClose()
                    }).catch( e => {
                        this.closeAllDialog()
                        this.paperErrorMessage = e.message
                        this.paperErrorDialogVisible = true
                    })
                }else {
                    // 托盘无纸
                    this.$emit('dishHaveNoPaper')
                }
            }).catch(e => {
                this.closeAllDialog()
                this.paperErrorMessage = e.message
                this.paperErrorDialogVisible = true
            })
        },
        handleDishNotClose(){
            clearTimeout(this.dishNotCloseTimer)
            this.dishNotCloseTimer = setTimeout(() => {
                this.closeAllDialog()
                this.timeoutDishDialogVisible = true
                this.handleCountDown()
            },this.intervalTime)
        },
        handleCountDown(){
            let remainingSeconds = 15;
            this.countDownNum = remainingSeconds
            let that =  this
            that.timerId = setInterval(function() {
                if (remainingSeconds === 0) {
                    clearInterval(that.timerId);
                    that.timeoutDishDialogVisible = false
                    that.recoverDish()
                } else {
                    that.countDownNum = remainingSeconds
                    remainingSeconds--;
                }
            }, 1000);
        },
        cancleRecoverDish(){
            this.closeAllDialog()
            this.restoreDialogVisible = true
            clearInterval(this.timerId)
            this.handleDishNotClose()
        },
        recoverDish(){
            if(this.dishNotCloseTimer) clearTimeout(this.dishNotCloseTimer)
            this.closeAllDialog()
            this.loadingDialogVisible = true
            this.loadingMsg = '正在收回托盘，请稍等...'
            this.restore().then(res => {
                this.loadingMsg = '托盘收回成功'
                this.$emit('dishHandleFinish')
                setTimeout(() => {
                    this.closeAllDialog()
                }, 1000)
            }).catch(e => {
                this.closeAllDialog()
                if(e.status === -7){
                    this.restoreDishDialogVisible = true
                }else {
                    this.paperErrorMessage = e.message
                    this.paperErrorDialogVisible = true
                }
            })
        },
        resetCloseDish(){
            this.closeAllDialog()
            this.loadingMsg = '正在关闭闸门，请稍后...'
            this.loadingDialogVisible = true
            this.resetDish().then(res => {
                this.loadingMsg = '闸门关闭成功'
                this.$emit('dishHandleFinish')
                setTimeout(() => {
                    this.closeAllDialog()
                },1000)
            }).catch(e => {
                this.closeAllDialog()
                if(e.status === 1){
                    // 重试关闭闸门
                    this.restoreDishDialogVisible= true
                }else {
                    this.paperErrorDialogVisible = true
                    this.paperErrorMessage = e.message
                }
            })
        },
        // 关闭全部弹窗
        closeAllDialog(){
            this.loadingDialogVisible = false
            this.paperErrorDialogVisible = false
            this.restoreDialogVisible = false
            this.restoreDishDialogVisible = false
            this.timeoutDishDialogVisible = false
        }
    }
}
</script>
<style lang="less" scoped>

</style>


